<div class="support-container">
  <!-- Header Section -->
  <!-- <div
    class="flex justify-content-between py-2 px-2 relative border-bottom-2 border-200"
  >
    <div>
      <img src="../../../assets/coinwush.png" style="width: 145px" />
    </div>
    <div
      class="text-sm font-semibold text-700 flex justify-content-between gap-3"
    >
      <div
        class="cursor-pointer text-center py-2 px-3 highlight-bg border-round-xs text-xs font-medium order-place button-color"
        (click)="navigate('/user/signup')"
      >
        <div>Sign Up</div>
      </div>
      <div class="flex align-items-center" (click)="sidebarVisible = true">
        <i class="pi pi-align-right"></i>
      </div>
    </div>
  </div> -->

  <!-- Hero Section -->
  <section class="flex justify-content-center px-3 mt-5 mb-6">
    <div class="text-center">
      <h1 class="text-4xl font-semibold text-700 letter-spacing">
        Support Centre
      </h1>
      <div
        class="mt-4 text-muted opacity-70 line-height-3 font-medium letter-spacing text-lg"
      >
        We're here to help you 24/7. Get the support you need, when you need it.
      </div>
    </div>
  </section>

  <!-- Quick Help Cards -->
  <section class="flex justify-content-center flex-wrap gap-4 px-3 mb-6">
    <div
      class="p-4 border-1 border-100 border-round-lg bg-white box cursor-pointer"
      style="max-width: 18rem"
      (click)="scrollToSection('faq')"
    >
      <div
        class="msg border-round-md flex align-items-center justify-content-center mx-auto"
        style="width: 50px; height: 50px"
      >
        <i
          class="pi pi-question-circle"
          style="font-size: 1.5rem; color: #2196f3"
        ></i>
      </div>
      <div class="mt-3 font-semibold text-lg text-700 text-center">FAQs</div>
      <div class="mt-2 opacity-70 text-muted line-height text-sm text-center">
        Find quick answers to commonly asked questions
      </div>
    </div>

    <div
      class="p-4 border-1 border-100 border-round-lg bg-white box cursor-pointer"
      style="max-width: 18rem"
      (click)="scrollToSection('contact')"
    >
      <div
        class="border-round-md flex align-items-center justify-content-center mx-auto msg"
        style="width: 50px; height: 50px"
      >
        <i class="pi pi-send" style="font-size: 1.5rem; color: #00bcd4"></i>
      </div>
      <div class="mt-3 font-semibold text-lg text-700 text-center">
        Contact Us
      </div>
      <div class="mt-2 opacity-70 text-muted line-height text-sm text-center">
        Reach out to our support team directly
      </div>
    </div>

    <div
      class="p-4 border-1 border-100 border-round-lg bg-white box cursor-pointer"
      style="max-width: 18rem"
      (click)="scrollToSection('guides')"
    >
      <div
        class="bg-soft-orange border-round-md flex align-items-center justify-content-center mx-auto"
        style="width: 50px; height: 50px"
      >
        <i class="pi pi-book" style="font-size: 1.5rem; color: #ff9800"></i>
      </div>
      <div class="mt-3 font-semibold text-lg text-700 text-center">
        Trading Guides
      </div>
      <div class="mt-2 opacity-70 text-muted line-height text-sm text-center">
        Learn how to trade on our platform
      </div>
    </div>

    <div
      class="p-4 border-1 border-100 border-round-lg bg-white box cursor-pointer"
      style="max-width: 18rem"
      (click)="scrollToSection('ticket')"
    >
      <div
        class="border-round-md flex align-items-center justify-content-center mx-auto bg-soft-success"
        style="width: 50px; height: 50px"
      >
        <i class="pi pi-ticket" style="font-size: 1.5rem; color: #4caf50"></i>
      </div>
      <div class="mt-3 font-semibold text-lg text-700 text-center">
        Raise a Ticket
      </div>
      <div class="mt-2 opacity-70 text-muted line-height text-sm text-center">
        Submit a support request for assistance
      </div>
    </div>
  </section>

  <!-- Search Bar -->
  <section class="flex justify-content-center px-3 mb-6">
    <div class="w-full" style="max-width: 40rem">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon bg-white">
          <i class="pi pi-search"></i>
        </span>
        <input
          type="text"
          pInputText
          placeholder="Search for help articles, guides, or FAQs..."
          [(ngModel)]="searchQuery"
          class="w-full"
        />
      </div>
    </div>
  </section>

  <!-- FAQ Section -->
  <section class="px-3 py-6 bg-white" id="faq">
    <div class="text-center mb-5">
      <h2 class="text-2xl font-semibold text-700">
        Frequently Asked Questions
      </h2>
      <div class="mt-2 text-muted opacity-70 text-sm">
        Quick answers to questions you may have
      </div>
    </div>

    <div class="flex justify-content-center">
      <div class="w-full" style="max-width: 50rem">
        <!-- Getting Started -->
        <div class="mb-4">
          <h3 class="text-lg font-semibold text-700 mb-3">Getting Started</h3>
          <p-accordion>
            <p-accordionTab header="How do I create an account on Coinwush?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                Creating an account is simple. Click on 'Sign Up' and complete
                the registration form with your email and phone number. You'll
                need to verify your email and complete KYC verification with
                your Aadhar and PAN card. The entire process takes less than 5
                minutes.
              </p>
            </p-accordionTab>

            <p-accordionTab
              header="What documents do I need for KYC verification?"
            >
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                You need a valid Aadhar card and PAN card for KYC verification.
                Make sure both documents are clear and readable. The
                verification process is completely digital and typically
                completes within 1-2 minutes.
              </p>
            </p-accordionTab>

            <p-accordionTab header="How do I deposit INR into my account?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                After KYC approval, link your bank account in the 'Deposit'
                section. You can then transfer INR directly from your bank.
                Deposits via UPI and IMPS are instant, while NEFT/RTGS may take
                30 minutes to 2 hours depending on your bank.
              </p>
            </p-accordionTab>
          </p-accordion>
        </div>

        <!-- Trading -->
        <div class="mb-4">
          <h3 class="text-lg font-semibold text-700 mb-3">Trading</h3>
          <p-accordion>
            <p-accordionTab header="Can I buy crypto on Coinwush?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                No, you cannot buy crypto on Coinwush. You can only trade crypto
                derivatives (futures and options) using INR. There's no need to
                own cryptocurrency to trade on our platform.
              </p>
            </p-accordionTab>

            <p-accordionTab header="Can I trade Spot on Coinwush?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                No, you cannot trade Spot on Coinwush currently. We specialize
                in futures and options trading. Spot trading feature is under
                development and will be available soon.
              </p>
            </p-accordionTab>

            <p-accordionTab header="What cryptocurrencies can I trade?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                Currently, you can trade futures and options on Bitcoin (BTC)
                and Ethereum (ETH). We offer daily, weekly, and monthly expiries
                to suit different trading strategies.
              </p>
            </p-accordionTab>

            <p-accordionTab header="What are the trading hours?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                Coinwush operates 24/7, 365 days a year. You can trade anytime,
                anywhere, as crypto markets never close.
              </p>
            </p-accordionTab>

            <p-accordionTab header="What is the minimum order size?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                The minimum order size varies by contract. For BTC futures, the
                minimum is typically 0.001 BTC, and for ETH futures, it's 0.01
                ETH. Check the contract specifications for exact details.
              </p>
            </p-accordionTab>
          </p-accordion>
        </div>

        <!-- Risk Management -->
        <div class="mb-4">
          <h3 class="text-lg font-semibold text-700 mb-3">Risk Management</h3>
          <p-accordion>
            <p-accordionTab
              header="What is liquidation and how can I avoid it?"
            >
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                Liquidation occurs when your margin balance is insufficient to
                keep a leveraged position open. This happens when the market
                moves against your trade beyond a certain threshold. To avoid
                liquidation: (1) Use appropriate leverage, (2) Maintain
                sufficient margin in your account, (3) Set stop-loss orders, and
                (4) Monitor your positions regularly.
              </p>
            </p-accordionTab>

            <p-accordionTab header="How does leverage work?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                Leverage allows you to control a larger position with a smaller
                amount of capital. For example, with 10x leverage, ₹1,000
                controls a ₹10,000 position. While leverage can amplify profits,
                it also amplifies losses. Always use leverage responsibly and
                understand the risks involved.
              </p>
            </p-accordionTab>

            <p-accordionTab header="What is margin and how is it calculated?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                Margin is the collateral required to open and maintain a
                leveraged position. We use smart margining that calculates your
                required margin based on your total portfolio risk. Your margin
                requirement is displayed before you place any order.
              </p>
            </p-accordionTab>
          </p-accordion>
        </div>

        <!-- Account & Security -->
        <div class="mb-4">
          <h3 class="text-lg font-semibold text-700 mb-3">
            Account & Security
          </h3>
          <p-accordion>
            <p-accordionTab
              header="How do I enable two-factor authentication (2FA)?"
            >
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                Go to Settings > Security > Two-Factor Authentication. Download
                Google Authenticator or any TOTP app, scan the QR code, and
                enter the 6-digit code to activate 2FA. We highly recommend
                enabling 2FA for enhanced security.
              </p>
            </p-accordionTab>

            <p-accordionTab header="What should I do if I forget my password?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                Click on 'Forgot Password' on the login page. Enter your
                registered email address, and we'll send you a password reset
                link. Follow the instructions in the email to create a new
                password.
              </p>
            </p-accordionTab>

            <p-accordionTab header="How do I withdraw funds?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                Go to the 'Withdraw' section, enter the amount you want to
                withdraw, and confirm. Funds will be transferred to your linked
                bank account. Withdrawals are processed within 1-4 hours during
                business days.
              </p>
            </p-accordionTab>

            <p-accordionTab header="Is my data secure on Coinwush?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                Yes, absolutely. We use bank-grade encryption (AES-256),
                multi-factor authentication, and 24/7 monitoring to protect your
                data and funds. We are also fully compliant with Indian data
                protection regulations.
              </p>
            </p-accordionTab>
          </p-accordion>
        </div>

        <!-- Fees & Charges -->
        <div class="mb-4">
          <h3 class="text-lg font-semibold text-700 mb-3">Fees & Charges</h3>
          <p-accordion>
            <p-accordionTab header="What are the trading fees?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                We offer 50% lower brokerage compared to other exchanges. Our
                maker fee is 0.02% and taker fee is 0.05%. Visit our Fee
                Schedule page for detailed information on all charges.
              </p>
            </p-accordionTab>

            <p-accordionTab header="Are there any deposit or withdrawal fees?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                Deposits are free. Withdrawal fees are minimal and cover bank
                processing charges. Standard withdrawals are ₹5 per transaction,
                while instant withdrawals may have slightly higher fees.
              </p>
            </p-accordionTab>

            <p-accordionTab header="Are there any hidden charges?">
              <p class="text-left m-0 text-sm text-700 opacity-60 line-height">
                No, we believe in complete transparency. All fees are clearly
                displayed before you confirm any transaction. There are no
                hidden charges or surprise fees.
              </p>
            </p-accordionTab>
          </p-accordion>
        </div>
      </div>
    </div>
  </section>

  <!-- Trading Guides Section -->
  <!-- <section class="px-3 py-6" id="guides">
    <div class="text-center mb-5">
      <h2 class="text-2xl font-semibold text-700">
        Trading Guides & Tutorials
      </h2>
      <div class="mt-2 text-muted opacity-70 text-sm">
        Learn how to make the most of our platform
      </div>
    </div>

    <div class="flex justify-content-center flex-wrap gap-4">
      <div
        class="p-4 border-1 border-100 border-round-lg bg-white box"
        style="max-width: 22rem"
      >
        <div
          class="msg border-round-md flex align-items-center justify-content-center"
          style="width: 50px; height: 50px"
        >
          <i
            class="pi pi-play-circle"
            style="font-size: 1.5rem; color: #2196f3"
          ></i>
        </div>
        <div class="mt-3 font-semibold text-700">Getting Started Guide</div>
        <div class="mt-2 opacity-70 text-muted line-height text-sm">
          Step-by-step walkthrough of account creation, KYC verification, and
          making your first deposit.
        </div>
        <div class="mt-3">
          <span class="cursor-pointer orange text-sm font-medium"
            >Read Guide →</span
          >
        </div>
      </div>

      <div
        class="p-4 border-1 border-100 border-round-lg bg-white box"
        style="max-width: 22rem"
      >
        <div
          class="border-round-md flex align-items-center justify-content-center msg"
          style="width: 50px; height: 50px"
        >
          <i
            class="pi pi-chart-line"
            style="font-size: 1.5rem; color: #00bcd4"
          ></i>
        </div>
        <div class="mt-3 font-semibold text-700">
          Understanding Futures Trading
        </div>
        <div class="mt-2 opacity-70 text-muted line-height text-sm">
          Learn the basics of futures contracts, leverage, margin requirements,
          and position management.
        </div>
        <div class="mt-3">
          <span class="cursor-pointer orange text-sm font-medium"
            >Read Guide →</span
          >
        </div>
      </div>

      <div
        class="p-4 border-1 border-100 border-round-lg bg-white box"
        style="max-width: 22rem"
      >
        <div
          class="bg-soft-orange border-round-md flex align-items-center justify-content-center"
          style="width: 50px; height: 50px"
        >
          <i class="pi pi-shield" style="font-size: 1.5rem; color: #ff9800"></i>
        </div>
        <div class="mt-3 font-semibold text-700">
          Risk Management Strategies
        </div>
        <div class="mt-2 opacity-70 text-muted line-height text-sm">
          Essential tips for managing risk, setting stop-losses, and protecting
          your capital.
        </div>
        <div class="mt-3">
          <span class="cursor-pointer orange text-sm font-medium"
            >Read Guide →</span
          >
        </div>
      </div>

      <div
        class="p-4 border-1 border-100 border-round-lg bg-white box"
        style="max-width: 22rem"
      >
        <div
          class="border-round-md flex align-items-center justify-content-center bg-soft-success"
          style="width: 50px; height: 50px"
        >
          <i
            class="pi pi-briefcase"
            style="font-size: 1.5rem; color: #4caf50"
          ></i>
        </div>
        <div class="mt-3 font-semibold text-700">Options Trading Basics</div>
        <div class="mt-2 opacity-70 text-muted line-height text-sm">
          Comprehensive guide to call and put options, strike prices, and option
          strategies.
        </div>
        <div class="mt-3">
          <span class="cursor-pointer orange text-sm font-medium"
            >Read Guide →</span
          >
        </div>
      </div>

      <div
        class="p-4 border-1 border-100 border-round-lg bg-white box"
        style="max-width: 22rem"
      >
        <div
          class="msg border-round-md flex align-items-center justify-content-center"
          style="width: 50px; height: 50px"
        >
          <i
            class="pi pi-calculator"
            style="font-size: 1.5rem; color: #2196f3"
          ></i>
        </div>
        <div class="mt-3 font-semibold text-700">P&L Analytics Dashboard</div>
        <div class="mt-2 opacity-70 text-muted line-height text-sm">
          How to use our analytics tools to track performance and improve your
          trading decisions.
        </div>
        <div class="mt-3">
          <span class="cursor-pointer orange text-sm font-medium"
            >Read Guide →</span
          >
        </div>
      </div>

      <div
        class="p-4 border-1 border-100 border-round-lg bg-white box"
        style="max-width: 22rem"
      >
        <div
          class="border-round-md flex align-items-center justify-content-center msg"
          style="width: 50px; height: 50px"
        >
          <i class="pi pi-mobile" style="font-size: 1.5rem; color: #00bcd4"></i>
        </div>
        <div class="mt-3 font-semibold text-700">Mobile Trading Guide</div>
        <div class="mt-2 opacity-70 text-muted line-height text-sm">
          Trade on the go with our mobile app. Learn tips and tricks for mobile
          trading.
        </div>
        <div class="mt-3">
          <span class="cursor-pointer orange text-sm font-medium"
            >Read Guide →</span
          >
        </div>
      </div>
    </div>
  </section> -->

  <!-- Contact Section -->

  <!-- Raise Ticket Section -->
  <!-- <section class="px-3 py-6" id="ticket">
    <div class="text-center mb-5">
      <h2 class="text-2xl font-semibold text-700">Raise a Support Ticket</h2>
      <div class="mt-2 text-muted opacity-70 text-sm">
        Can't find what you're looking for? Submit a ticket and we'll get back
        to you
      </div>
    </div>

    <div class="flex justify-content-center">
      <div
        class="w-full bg-white p-5 border-round-lg border-1 border-100"
        style="max-width: 40rem"
      >
        <form>
          <div class="mb-4">
            <label class="block text-sm font-medium text-700 mb-2"
              >Your Name</label
            >
            <input
              type="text"
              pInputText
              class="w-full"
              placeholder="Enter your full name"
              [(ngModel)]="ticketForm.name"
              name="name"
            />
          </div>

          <div class="mb-4">
            <label class="block text-sm font-medium text-700 mb-2"
              >Email Address</label
            >
            <input
              type="email"
              pInputText
              class="w-full"
              placeholder="your.email@example.com"
              [(ngModel)]="ticketForm.email"
              name="email"
            />
          </div>

          <div class="mb-4">
            <label class="block text-sm font-medium text-700 mb-2"
              >Category</label
            >
            <p-dropdown
              [(ngModel)]="ticketForm.category"
              placeholder="Select a category"
              [style]="{ width: '100%' }"
              name="category"
            ></p-dropdown>
          </div>

          <div class="mb-4">
            <label class="block text-sm font-medium text-700 mb-2"
              >Subject</label
            >
            <input
              type="text"
              pInputText
              class="w-full"
              placeholder="Brief description of your issue"
              [(ngModel)]="ticketForm.subject"
              name="subject"
            />
          </div>

          <div class="mb-4">
            <label class="block text-sm font-medium text-700 mb-2"
              >Description</label
            >
            <textarea
              pInputTextarea
              [rows]="5"
              class="w-full"
              placeholder="Provide detailed information about your issue..."
              [(ngModel)]="ticketForm.description"
              name="description"
            ></textarea>
          </div>

          <div class="mb-4">
            <label class="block text-sm font-medium text-700 mb-2"
              >Priority</label
            >
            <div class="flex gap-3">
              <p-radioButton
                name="priority"
                value="low"
                [(ngModel)]="ticketForm.priority"
                inputId="low"
              ></p-radioButton>
              <label for="low" class="cursor-pointer">Low</label>

              <p-radioButton
                name="priority"
                value="medium"
                [(ngModel)]="ticketForm.priority"
                inputId="medium"
              ></p-radioButton>
              <label for="medium" class="cursor-pointer">Medium</label>

              <p-radioButton
                name="priority"
                value="high"
                [(ngModel)]="ticketForm.priority"
                inputId="high"
              ></p-radioButton>
              <label for="high" class="cursor-pointer">High</label>
            </div>
          </div>

          <div class="mb-4">
            <label class="block text-sm font-medium text-700 mb-2"
              >Attach Files (Optional)</label
            >
       
            <div class="text-xs text-muted mt-2">
              Max file size: 5MB. Supported formats: JPG, PNG, PDF, DOC
            </div>
          </div>

          <div class="flex justify-content-end gap-3">
            <button
              type="button"
              class="py-2 px-4 border-1 border-200 border-round-sm cursor-pointer bg-white text-700"
              (click)="resetForm()"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="py-2 px-4 highlight-bg border-round-sm cursor-pointer text-white border-none"
              (click)="submitTicket($event)"
            >
              Submit Ticket
            </button>
          </div>
        </form>
      </div>
    </div>
  </section> -->

  <!-- Additional Resources -->
  <!-- <section class="px-3 py-6 bg-white mb-6">
    <div class="text-center mb-5">
      <h2 class="text-2xl font-semibold text-700">Additional Resources</h2>
    </div>

    <div class="flex justify-content-center flex-wrap gap-4">
      <div
        class="p-4 border-1 border-100 border-round-lg box cursor-pointer"
        style="max-width: 18rem"
      >
        <div class="flex align-items-center gap-3">
          <i class="pi pi-book orange" style="font-size: 1.5rem"></i>
          <div>
            <div class="font-semibold text-700">Knowledge Base</div>
            <div class="text-xs text-muted mt-1">
              Comprehensive documentation
            </div>
          </div>
        </div>
      </div>

      <div
        class="p-4 border-1 border-100 border-round-lg box cursor-pointer"
        style="max-width: 18rem"
      >
        <div class="flex align-items-center gap-3">
          <i class="pi pi-youtube orange" style="font-size: 1.5rem"></i>
          <div>
            <div class="font-semibold text-700">Video Tutorials</div>
            <div class="text-xs text-muted mt-1">Step-by-step video guides</div>
          </div>
        </div>
      </div>

      <div
        class="p-4 border-1 border-100 border-round-lg box cursor-pointer"
        style="max-width: 18rem"
      >
        <div class="flex align-items-center gap-3">
          <i class="pi pi-users orange" style="font-size: 1.5rem"></i>
          <div>
            <div class="font-semibold text-700">Community Forum</div>
            <div class="text-xs text-muted mt-1">
              Connect with other traders
            </div>
          </div>
        </div>
      </div>

      <div
        class="p-4 border-1 border-100 border-round-lg box cursor-pointer"
        style="max-width: 18rem"
      >
        <div class="flex align-items-center gap-3">
          <i class="pi pi-file-pdf orange" style="font-size: 1.5rem"></i>
          <div>
            <div class="font-semibold text-700">API Documentation</div>
            <div class="text-xs text-muted mt-1">
              For developers and algo traders
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> -->


</div>
